<template>
	<div class="modal flex-ccc" :class="visible ? 'modal-show': ''" v-if="visible"  @touchmove.stop="void 0">
		<div class="modal-main">
			<div class="modal-content">
				<div v-if="title" class="modal-title">{{ title }}</div>
				<div class="modal-body">
					<slot></slot>
				</div>
				<div class="modal-btn flex-rsc">
					<button class="button-default cancel-button-default"  @click.stop="hideModal">
						{{ cancelText }}
					</button>
					<button class="button-default confirm-button-default" @click.stop="handleOk">
						{{ okText }}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: '提示'
      },
      content: {
        type: String,
        default: ''
      },
      cancelText: {
        type: String,
        default: '取消'
      },
      okText: {
        type: String,
        default: '确定'
      }
    },
    computed: {
      ...mapState(['isApp'])
    },
    methods: {
      hideModal () {
        this.$emit('hideModal')
      },
      handleOk () {
        this.$emit('ok')
      }
    }
  }
</script>

<style lang="stylus" scoped>
	.modal{
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.7);
		z-index: 200;
		opacity: 0;
		visibility: hidden;
		&.modal-show{
			visibility: visible;
			opacity: 1;
		}
		.modal-mask{
			position: fixed;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
		}
		.modal-content{
			width: 330px;
			border-radius: 8px;
			background: #ffffff;
			.modal-title{
				margin-bottom: 5px;
				padding 15px 0
				text-align: center;
				font-size: 15px;
				font-weight: 800;
				color: #333;
			}
			.modal-body{
				font-size: 14px;
				line-height: 1.5;
				color: #666;
				img{
					width: 100%;
				}
			}
			.modal-btn{
				padding 15px 10px
				border-1px(solid, #EBEBEB)
				button{
					width: 135px;
					height: 40px;
					margin 0 10px
					line-height: 40px;
					font-size: 15px;
					text-align: center;
					border-radius: 40px;
				}
			}
			
		}
	}
</style>
